import React from "react";

const Forbidden = () => {
  return <div>Not authorized</div>;
};

export default Forbidden;
